<script>import { getContext } from 'svelte';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
import { twMerge } from 'tailwind-merge';
const forwardEvents = forwardEventsBuilder(get_current_component());
const type = getContext('alert-type');
const alertDescription = getContext('alert-description');
const defaultClass = 'flex-shrink-0 flex items-center justify-center stwui-alert-extra';
const infoClass = 'text-info-icon ';
const warnClass = 'text-warn-icon';
const successClass = 'text-success-icon';
const errorClass = 'text-error-icon';
$: finalClass = twMerge(defaultClass, $type === 'info' ? infoClass : false, $type === 'warn' ? warnClass : false, $type === 'success' ? successClass : false, $type === 'error' ? errorClass : false, alertDescription ? 'absolute top-2.5 right-2.5' : false, $$props.class);
</script>

<div
	aria-label="alert extra"
	class={finalClass}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
>
	<slot />
</div>
